module.exports = __webpack_public_path__ + "static/img/headerBanner.b34ba99.png";


//////////////////
// WEBPACK FOOTER
// ./static/index/headerBanner.png
// module id = ndwh
// module chunks = 1